import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestForm = get('guest.components.guestForm');

export const getIsSaving = createSelector(getGuestForm, get('saving'));
export const getIsSaved = createSelector(getGuestForm, get('saved'));
export const getSavingError = createSelector(getGuestForm, get('savingError'));
export const getIsUploadingFile = createSelector(
  getGuestForm,
  get('isUploadingFile')
);
